import type { ReactNode } from "react";
import { RouteScroller } from "@client/components/utils/RouteScroller";
import { LoginPanel } from "./LoginButton";
import "./welcomeLanding.css";

export function WelcomeLanding({
  error,
  applications,
}: {
  error?: string;
  applications?: ReactNode;
}) {
  return (
    <RouteScroller className="bg-background">
      <span hidden data-application-theme="green" />
      <main className="mx-auto flex min-h-full max-w-7xl flex-col px-6 py-8 md:px-12 md:py-16">
        <div className="grid items-start gap-10 lg:grid-cols-2 lg:gap-20">
          <section className="max-w-lg">
            <p className="mb-4 body-md text-muted-foreground">
              Survival &amp; Flourishing Fund
            </p>
            <h1 className="welcome-headline text-4xl leading-none tracking-[-0.03em] md:text-5xl">
              Empowering organizations to secure humanity’s future
            </h1>
            <p className="mt-6 max-w-md body-lg text-muted-foreground">
              Apply for funding, follow your application, or help decide which
              work to support.
            </p>
          </section>

          <section
            aria-labelledby="welcome-sign-in"
            className="w-full max-w-lg rounded-xl border border-border bg-card p-6 sm:p-10 lg:justify-self-end"
          >
            <h2 id="welcome-sign-in" className="heading-lg">
              Welcome to S-Process
            </h2>
            <p className="mb-8 mt-2 body-md text-muted-foreground">
              Your applications and funding rounds, in one place.
            </p>
            <LoginPanel variant="welcome" />
            {error && (
              <p role="alert" className="mt-4 body-md text-destructive">
                Error: {error}
              </p>
            )}
          </section>
        </div>
        {applications}
        <footer className="mt-10 body-sm text-muted-foreground">
          <a
            href="https://survivalandflourishing.fund/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Learn about Survival & Flourishing Fund (opens in a new tab)"
            className="rounded-sm underline underline-offset-4 hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ring"
          >
            Learn about Survival &amp; Flourishing Fund ↗
          </a>
        </footer>
      </main>
    </RouteScroller>
  );
}
